import ThemeButton from 'components/ui/Button/ThemeButton';
import Text from 'components/ui/Text';
import useAppDispatch from 'hooks/useAppDispatch';
import useAppSelector from 'hooks/useAppSelector';
import { FormEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { lookupWithdrawalOrder, selectWithdrawal, withdrawalReset } from 'store/reducers/withdrawalSlice';
import { WITHDRAWAL_ROUTES } from 'utils/withdrawalRoutes';
import { Field, Message } from './WithdrawalStyles';

const WithdrawalLookup = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { lookupStatus } = useAppSelector(selectWithdrawal);

    const [orderNumber, setOrderNumber] = useState('');
    const [email, setEmail] = useState('');

    useEffect(() => {
        dispatch(withdrawalReset());
    }, [dispatch]);

    const submitting = lookupStatus === 'pending';
    const canSubmit = orderNumber.trim().length > 0 && email.trim().length > 0 && !submitting;

    const onSubmit = async (event: FormEvent) => {
        event.preventDefault();
        if (!canSubmit) return;
        const result = await dispatch(lookupWithdrawalOrder({ orderNumber: orderNumber.trim(), email: email.trim() }));
        if (lookupWithdrawalOrder.fulfilled.match(result)) navigate(WITHDRAWAL_ROUTES.selection);
    };

    return (
        <form onSubmit={onSubmit} noValidate>
            <h1>{t('withdrawal_lookup_title')}</h1>
            <Text light className="mb-3">
                {t('withdrawal_lookup_intro')}
            </Text>

            <Field>
                <label htmlFor="withdrawal-order-number">{t('order_number')}</label>
                <input
                    id="withdrawal-order-number"
                    className="form-control"
                    autoComplete="off"
                    value={orderNumber}
                    onChange={(e) => setOrderNumber(e.target.value)}
                />
            </Field>

            <Field>
                <label htmlFor="withdrawal-email">{t('email')}</label>
                <input
                    id="withdrawal-email"
                    className="form-control"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </Field>

            {lookupStatus === 'notFound' && <Message role="alert">{t('withdrawal_not_found')}</Message>}
            {lookupStatus === 'rateLimited' && <Message role="alert">{t('withdrawal_too_many')}</Message>}
            {lookupStatus === 'error' && <Message role="alert">{t('withdrawal_lookup_error')}</Message>}

            <ThemeButton
                pill={false}
                className="mt-3"
                loading={submitting}
                disabled={!canSubmit}
                text={t('continue')}
            />
        </form>
    );
};

export default WithdrawalLookup;
